import React from "react";
import { Link } from "@mui/material";
import { Typography } from "@financeable-com-au/financeable-ui";
import { scrollToElementById } from "@/utils/commonFunctions";
import { MissingRequiredField } from "@/utils/requiredFieldRules";

interface MissingRequiredFieldsProps {
  fields: MissingRequiredField[];
  prefix?: string;
}

const anchorLinkStyle = {
  verticalAlign: "baseline",
  font: "inherit",
  letterSpacing: "inherit",
  p: 0,
  border: 0,
  background: "none",
  cursor: "pointer",
};

/**
 * Renders "Requires make, model, condition" where every field that has an anchor is a
 * link that scrolls the user straight to the input they still need to fill in.
 */
const MissingRequiredFields = ({ fields, prefix = "Requires" }: MissingRequiredFieldsProps) => {
  if (!fields.length) return null;

  return (
    <Typography level="body-xs" component="span">
      {prefix}{" "}
      {fields.map((field, index) => (
        <React.Fragment key={field.key}>
          {index > 0 ? ", " : ""}
          {field.anchorId ? (
            <Link
              component="button"
              type="button"
              underline="hover"
              onClick={() => scrollToElementById({ elementId: field.anchorId })}
              sx={anchorLinkStyle}
            >
              {field.label}
            </Link>
          ) : (
            field.label
          )}
        </React.Fragment>
      ))}
    </Typography>
  );
};

export default MissingRequiredFields;
